import { useEffect, useState } from "react";
import { Input } from "./ui/input";
import { CheckCheckIcon, CircleXIcon, EditIcon } from "lucide-react";
import { Button } from "./ui/button";
import { LoadingSmall } from "./LoadingSmall";

interface Props {
  initialText: string;
  onSave: (text: string) => void;
  isLoading?: boolean;
  isFinishedLoading?: boolean;
}

export const EditableText: React.FC<Props> = ({ initialText, onSave, isLoading, isFinishedLoading }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [text, setText] = useState(initialText);

  useEffect(() => {
    if (isFinishedLoading) {
      setIsEditing(false);
    }
  }, [isFinishedLoading, setIsEditing]);

  const cancelEditing = () => {
    setIsEditing(false);
    setText(initialText);
  };

  return (
    <div>
      {isEditing ? (
        <div className="flex items-center gap-2">
          <Input
            autoFocus
            value={text}
            className="w-[200px]"
            onChange={(e) => setText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Escape") {
                cancelEditing();
              }
              if (e.key === "Enter") {
                onSave(text);
              }
            }}
          />
          <Button
            onClick={() => {
              onSave(text);
            }}
            size="sm"
          >
            {isLoading ? <LoadingSmall /> : <CheckCheckIcon />}
          </Button>
          {!isLoading && (
            <Button size="sm" variant="outline" onClick={cancelEditing}>
              <CircleXIcon />
            </Button>
          )}
        </div>
      ) : (
        <div className="flex items-center gap-2">
          {text}
          <span onClick={() => setIsEditing(true)}>
            <EditIcon className="cursor-pointer w-4 h-4" />
          </span>
        </div>
      )}
    </div>
  );
};
